// extracted by mini-css-extract-plugin
module.exports = {"root":"CompleteLink_root__T4e3g","rootSuccess":"CompleteLink_rootSuccess__7CSN4","rootFailure":"CompleteLink_rootFailure__3Dym6","isDisabled":"CompleteLink_isDisabled__1hbM7"};